import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaBarsStaggered } from "react-icons/fa6";
import SideBar from "../SideBar";
import SwachhataCertificatePanel from "./SwachhataCertificate";
import { useGetSwachhataStatusQuery, useMarkSwachhataCertificateDownloadedMutation } from "../../../redux/auth/authApi";
import { CAMPAIGN } from "./swachhataContent";
import "./Swachhata.css";

/*
 * /school/swachhata-certificate — the school's Swachhata Hi Seva participation
 * certificate (same page chrome as the plantation certificate). Available once
 * the school has submitted the campaign quiz; otherwise it offers to open the
 * campaign popup.
 */
export default function SwachhataCertificatePage() {
  const user = useSelector((s) => s.auth.user);
  const [openSidebar, setOpenSidebar] = useState(false);
  const { data, isLoading, isError } = useGetSwachhataStatusQuery(undefined, { skip: !user });
  const [markDownloaded] = useMarkSwachhataCertificateDownloadedMutation();

  const participation = data?.participation || null;
  const submitted = participation?.survey?.status === "submitted";

  return (
    <section className="scholdashbrdSec">
      <div className="desktopView" style={{ marginTop: 70, textAlign: "end" }}>
        <Link className="button green bars" onClick={() => setOpenSidebar((o) => !o)}>
          <FaBarsStaggered size={20} />
        </Link>
      </div>
      <div className={`sidebar ${openSidebar ? "open" : "hideen"}`}>
        <SideBar index={11} role={user?.role} />
      </div>
      <div className="schlDashbrdRgt">
        <div className="row">
          <div className="col-md-12">
            <div className="card-user pageContainer">
              <div className="d-flex justify-content-between align-items-center card-header">
                <h5 className="card-title">{`${CAMPAIGN.name} Certificate`}</h5>
              </div>
              <div className="card-body">
                {isLoading && (
                  <div className="shs-loading" style={{ position: "relative", minHeight: 240 }}>
                    <span className="shs-spinner" />
                    {"Loading your certificate…"}
                  </div>
                )}
                {!isLoading && isError && (
                  <div className="shs-error">{"Could not load your Swachhata Hi Seva record. Please reload the page."}</div>
                )}
                {!isLoading && !isError && submitted && (
                  <SwachhataCertificatePanel
                    kind="school"
                    participation={participation}
                    onDownloaded={(format) => markDownloaded({ format }).catch(() => {})}
                    onBack={undefined}
                  />
                )}
                {!isLoading && !isError && !submitted && (
                  <div className="shs-page" style={{ borderRadius: 22, minHeight: 0 }}>
                    <div className="shs-shell shs-shell--welcome" style={{ height: "auto" }}>
                      <div className="shs-intro" style={{ padding: "40px 44px" }}>
                        <span className="shs-badge-pill"><i />{`Certificate · ${CAMPAIGN.name}`}</span>
                        <h2 className="shs-slide__title" style={{ marginTop: 14 }}>Fill in the Swachhata Hi Seva 2026 form to unlock your certificate</h2>
                        <p className="shs-slide__lead">
                          {"Your school's participation certificate is issued as soon as its Solid Waste Management report is submitted. Fill in the form and come back here to download it."}
                        </p>
                        <div className="shs-intro__actions">
                          <button
                            type="button"
                            className="shs-btn shs-btn--orange shs-btn--lg"
                            onClick={() => window.dispatchEvent(new Event("openSwachhataModal"))}
                          >
                            {"Fill the form"} <span className="shs-btn__arrow">→</span>
                          </button>
                          <Link to="/school/schooldashboard" className="shs-btn shs-btn--ghost">Back to dashboard</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
